<h2 mat-dialog-title>Self Check In/Check Out History</h2>
<div style="padding-left: 10px;">{{studentName}} - {{studentNumber}}</div>

<mat-dialog-content>
  <div *ngIf="angularMatData.data.length == 0" style="text-align: center;">No Self Check In/Check Out History exists for student</div>
  <div *ngIf="angularMatData.data.length > 0">
      <mat-table #table [dataSource]="angularMatData" style="padding-top: 30px;" matSort matSortDisableClear matSortActive="Date"
        matSortDirection="asc">

        <!-- Type -->
        <ng-container matColumnDef='Type'>
          <mat-header-cell *matHeaderCellDef mat-sort-header="Type">Type
            <filter class="mat-filter" [data]="angularMatData" columnName="Type" dataType="string"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.Type}}</mat-cell>
        </ng-container>

        <!-- Date -->
        <ng-container matColumnDef='Date'>
          <mat-header-cell *matHeaderCellDef mat-sort-header="Date">Date
            <filter class="mat-filter" [data]="angularMatData" columnName="Date" dataType="string"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.Date |  date: 'MM/dd/yy'}}</mat-cell>
        </ng-container>

        <!-- Time -->
        <ng-container matColumnDef='Time'>
          <mat-header-cell *matHeaderCellDef mat-sort-header="Time">
            Time
            <filter class="mat-filter" [data]="angularMatData" columnName="Time" dataType="string"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.Time}}</mat-cell>
        </ng-container>

        <!-- Status -->
        <ng-container matColumnDef='Status'>
          <mat-header-cell *matHeaderCellDef mat-sort-header="Status">
            Status
            <filter class="mat-filter" [data]="angularMatData" columnName="Status" dataType="string"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.Status}}</mat-cell>
        </ng-container>

        <!-- Submitted By -->
        <ng-container matColumnDef='SubmittedBy'>
          <mat-header-cell *matHeaderCellDef mat-sort-header="SubmittedBy">
            Submitted By
            <filter class="mat-filter" [data]="angularMatData" columnName="SubmittedBy" dataType="string"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.SubmittedBy}}</mat-cell>
        </ng-container>

        <!-- Attachment -->
        <ng-container matColumnDef='Attachment'>
          <mat-header-cell *matHeaderCellDef mat-sort-header="Attachment">
            <img src="./assets/images/paperclip.png" alt="paperclip" style="height: 20px" />
          </mat-header-cell>
          <mat-cell *matCellDef="let st">
            <a *ngIf="st.Attachment" class="link" (click)="viwAttachments(st.Id)">Y</a>
            <span *ngIf="!st.Attachment"></span>
          </mat-cell>
        </ng-container>

        <!-- Reason -->
        <ng-container matColumnDef='Reason'>
          <mat-header-cell *matHeaderCellDef mat-sort-header="Reason">
            Reason
            <filter class="mat-filter" [data]="angularMatData" columnName="Reason" dataType="string"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let st">{{st.Reason}}</mat-cell>
        </ng-container>

        <!-- Action -->
        <ng-container matColumnDef='Action'>
          <mat-header-cell *matHeaderCellDef mat-sort-header="Action">
            Action
          </mat-header-cell>
          <mat-cell *matCellDef="let st">
            <a *ngIf="st.Status == 'Submitted'" class="link" (click)="deleteClick(st.Id)">Delete</a>
            <span *ngIf="st.Status != 'Submitted'"></span>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columnsToDisplay"
          style="position:sticky;top:0;z-index:100;background:white;padding:0px;">
        </mat-header-row>
        <mat-row *matRowDef="let row; columns: columnsToDisplay;"
          style="padding:0px;align-items: start;overflow: hidden;">
        </mat-row>
      </mat-table>
    </div>
</mat-dialog-content>

<mat-dialog-actions #footer>
  <div class='flex-footer-left'>

  </div>

  <div class='flex-footer-right'>
      <tyl-button image="Cancel.png" label="Close" (click)="cancelClick()"></tyl-button>
  </div>
</mat-dialog-actions>
